import { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminGuard from '../../components/admin/AdminGuard';
import { supabase } from '../../lib/supabase';
import { fetchAllProjectsAdmin, deleteProjectAdmin, toggleProjectVisibilityAdmin } from '../../services/adminService';

export default function AdminDashboardPage() {
  const [projects, setProjects] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [toggling, setToggling] = useState(null); // id being toggled
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    setProjects(await fetchAllProjectsAdmin());
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`"${title}"을(를) 삭제할까요?`)) return;
    await deleteProjectAdmin(id);
    load();
  };

  const handleToggleVisibility = async (p) => {
    setToggling(p.id);
    try {
      await toggleProjectVisibilityAdmin(p.id, !p.is_visible);
      setProjects((prev) =>
        prev.map((item) => item.id === p.id ? { ...item, is_visible: !p.is_visible } : item)
      );
    } catch (e) {
      alert(e.message);
    }
    setToggling(null);
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/admin');
  };

  return (
    <AdminGuard>
      <div className="admin-page">
        <header className="admin-header">
          <span className="admin-header-title">Admin</span>
          <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
            <Link to="/admin/featured" className="admin-btn-ghost">홈 피처드</Link>
            <Link to="/admin/contact" className="admin-btn-ghost">Contact 편집</Link>
            <Link to="/admin/projects/new" className="admin-btn-primary">+ 새 프로젝트</Link>
            <button onClick={handleLogout} className="admin-btn-ghost">로그아웃</button>
          </div>
        </header>

        <main className="admin-main">
          <h2 className="admin-section-title">Projects ({projects.length})</h2>

          {loading ? (
            <p className="admin-loading">불러오는 중...</p>
          ) : projects.length === 0 ? (
            <p className="admin-loading">프로젝트가 없습니다.</p>
          ) : (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>제목</th>
                    <th>타입</th>
                    <th>날짜</th>
                    <th>상태</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {projects.map((p) => (
                    <tr key={p.id} style={{ opacity: p.is_visible ? 1 : 0.55 }}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          {p.thumbnail_url && (
                            <img
                              src={p.thumbnail_url} alt=""
                              style={{ width: 36, height: 28, objectFit: 'cover', borderRadius: 4, flexShrink: 0, background: '#f3f4f6' }}
                            />
                          )}
                          <div>
                            <span style={{ fontWeight: 500 }}>{p.title}</span>
                            {p.is_main_only && (
                              <span className="admin-badge admin-badge--main" style={{ marginLeft: '0.375rem' }}>메인전용</span>
                            )}
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="admin-badge">{p.project_type}</span>
                      </td>
                      <td style={{ color: 'var(--c-n500)', fontSize: '0.8125rem' }}>
                        {p.project_date || '—'}
                      </td>
                      <td>
                        <button
                          className={`admin-feat-toggle${p.is_visible ? ' admin-feat-toggle--on' : ''}`}
                          onClick={() => handleToggleVisibility(p)}
                          disabled={toggling === p.id}
                          title={p.is_visible ? '노출 중 (클릭 → 숨김)' : '숨김 (클릭 → 노출)'}
                        >
                          {toggling === p.id ? '…' : p.is_visible ? '노출' : '숨김'}
                        </button>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                          <Link to={`/admin/projects/${p.id}/edit`} className="admin-btn-sm">편집</Link>
                          <button
                            onClick={() => handleDelete(p.id, p.title)}
                            className="admin-btn-sm admin-btn-sm--danger"
                          >삭제</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </main>
      </div>
    </AdminGuard>
  );
}
